import { useContext, useState } from 'react';
import { OrderContext } from '../context/OrderContext';

const useCompleteClaim = () => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {apiClient, uuid, setRefundProduct} = useContext(OrderContext);


  const completeClaim = async (product_id, note) => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.post(`api/v1/refund/${uuid}/complete_claim/`, {
        order_product_id : product_id,
        note : note
      });
      const data = response.data;
      let claims_sessions=  sessionStorage.setItem('refundProduct', JSON.stringify(data.claims));
      setRefundProduct(data.claims)
      return data;

    } catch (error) {
      const msg = error.response?.data?.error || error.message || 'API error';
      setError(msg);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {completeClaim};
};

export default useCompleteClaim;
